import * as React from 'react'

import { IItem } from '../../../../typings/searchResults'
import MoneyIcon from '../../icons/homePage/money'
import TimeIcon from '../../icons/homePage/time'
import UniqIcon from '../../icons/homePage/uniq'
import PopularIcon from '../../icons/homePage/popular'
import SupportIcon from '../../icons/homePage/support'
import QualityIcon from '../../icons/homePage/quality'
import { reportBlockClick } from '../../../../common/analytics/homePageAnalytics'
import { IHomePageBlockComponent } from '../../../../typings/pageBlocks'
import ItemsSlideBlock from '../itemsSlideBlock/itemsSlideBlock'

import * as styles from './valuePropositionBlock.module.css'

interface ITiles {
  title: string
  description: string
  icon: string
}

interface IProps extends IHomePageBlockComponent {
  title: string
  tiles: ITiles[]
  data: IItem[]
}

const icons = new Map([
  ['money', MoneyIcon],
  ['time', TimeIcon],
  ['uniq', UniqIcon],
  ['popular', PopularIcon],
  ['support', SupportIcon],
  ['quality', QualityIcon]
])

const reportValuePropositionBlockClick = (
  eventLabel: string,
  eventValue?: number
) => {
  reportBlockClick('Value Proposition', {
    dimension19: 'body',
    eventAction: 'click;link',
    eventLabel,
    eventValue
  })
}

const ValuePropositionBlock = ({ data, title, tiles }: IProps) => {
  return (
    <ItemsSlideBlock
      title={title}
      data={data}
      headerAlign="right"
      hideSlideOnMobile
      onItemClick={(item, index) =>
        reportValuePropositionBlockClick(`${item.id}`, index)
      }
      testSelector="valuePropositionBlock"
    >
      <div className={styles.tilesArea}>
        {tiles.map((tile, index) => {
          const Icon = icons.get(tile.icon)
          return (
            <div className={styles.tile} key={index}>
              {Icon && (
                <div className={styles.tileIcon}>
                  <Icon width="48" height="48" />
                </div>
              )}
              <div className={styles.tileContent}>
                {tile.title && (
                  <h3 className={styles.tileTitle}>{tile.title}</h3>
                )}
                <div className={styles.tileDescription}>{tile.description}</div>
              </div>
            </div>
          )
        })}
      </div>
    </ItemsSlideBlock>
  )
}

export default ValuePropositionBlock
